import { useIntl } from "react-intl";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CustomIcon from "../CustomIcon";
import icons from "../../enums/icons";

import { flattenSectorProductsDomain } from "services/company/company.functions";

// Styles
import companySummaryStyles from "./CompanySummary.styles";

const CompanySummaryBody = ({
    companyData,
    projection,
}: {
    companyData: ReturnType<typeof flattenSectorProductsDomain> | undefined;
    projection?: boolean;
}) => {
    const classes = companySummaryStyles();
    const intl = useIntl();

    const description = companyData?.description;
    const employeeCount = companyData?.employee_count ?? "?";
    const mainOffice = companyData?.locations?.at(0)?.country?.name ?? "?";

    return (
        <>
            <Box className={classes.summaryItemContainer}>
                <Box className={classes.summaryItem}>
                    <CustomIcon icon={icons.office} className={classes.summaryItemIcon} />
                    <Box component="span">{intl.formatMessage({ id: "companySummary.mainOffice" })}</Box>
                    <Box className={classes.summaryItemValue}>{mainOffice}</Box>
                </Box>
                <Box className={classes.summaryItem}>
                    <CustomIcon icon={icons.graph} className={classes.summaryItemIcon} />
                    <Box component="span">{intl.formatMessage({ id: "companySummary.employees" })}</Box>
                    <Box className={classes.summaryItemValue}>{employeeCount}</Box>
                </Box>

                {projection ? (
                    <Box className={classes.summaryItem}>
                        <CustomIcon icon={icons.paper} className={classes.summaryItemIcon} />
                        <Box component="span">{intl.formatMessage({ id: "companySummary.about" })}</Box>
                        <Box className={classes.summaryItemValue}>
                            <Typography variant="body1">{description}</Typography>
                        </Box>
                    </Box>
                ) : null}
            </Box>
        </>
    );
};

export default CompanySummaryBody;
